export class UserModel {
  public firstName: string;
  public lastName: string;
  public companyName: string;
  public designation: string;
  public username: string;
  public email: string;
  public companyId: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.firstName = '';
      this.lastName = '';
      this.companyName = '';
      this.designation = '';
      this.username = '';
      this.email = '';
      this.companyId = '';
    }
  }
}
